import React, {ReactNode, useState} from 'react';
import {useLeafletMap} from "@ui/leafletCustom/hooks/useLeafletMap";
import {useLeafletMapEvents} from "@ui/leafletCustom/hooks/useLeafletMapEvents";


export const MapZoomLevelContext = React.createContext<number>(0)

interface IProps {
    children?: ReactNode
}

const MapFeaturesContextProvider = ({children}: IProps) => {

    const map = useLeafletMap()

    const [zoomLevel, setZoomLevel] = useState(() => map.getZoom());

    const mapEvents = useLeafletMapEvents({
        zoomend: () => {
            setZoomLevel(mapEvents.getZoom());
        },
    });

    return (
        <MapZoomLevelContext.Provider
            value={zoomLevel}
        >
            {children}
        </MapZoomLevelContext.Provider>
    );
};

export default MapFeaturesContextProvider;